// extracted by mini-css-extract-plugin
export default {"countdown":"Countdown_countdown__zlXwT"};